@if (accessDenied()) {
<app-access-denied />
} @else if (failed()) {
<div class="text-foreground flex flex-col items-center gap-4 px-4 py-12 text-center text-base" role="alert"
  data-cy="login-callback-error">
  <p>{{ 'auth.loginFailed' | translate }}</p>
  <a hlmBtn variant="secondary" size="lg" routerLink="/home" data-cy="login-callback-retry">{{ 'auth.retry' | translate }}</a>
</div>
}
